import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hide-mobile" }
const _hoisted_2 = { class: "greenboard-bottom" }
const _hoisted_3 = {
  key: 0,
  class: "belt-info"
}
const _hoisted_4 = {
  key: 1,
  class: "configuration-error"
}
const _hoisted_5 = {
  key: 2,
  class: "complete-buttons"
}
const _hoisted_6 = {
  class: "hide-desktop",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_7 = {
  key: 0,
  class: "complete-buttons",
  style: {"height":"100%"}
}
const _hoisted_8 = {
  key: 0,
  class: "configuration-error"
}
const _hoisted_9 = { class: "complete-col" }
const _hoisted_10 = { class: "complete-col checkout-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Greenboard = _resolveComponent("Greenboard")!
  const _component_CopyLinkButton = _resolveComponent("CopyLinkButton")!
  const _component_CheckoutButton = _resolveComponent("CheckoutButton")!
  const _component_FormTab = _resolveComponent("FormTab")!

  return (_openBlock(), _createBlock(_component_FormTab, {
    class: "complete-content",
    index: _ctx.index
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Greenboard),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.configBagsizeId == _ctx.bagsizeSettings.bagsizeOptions[1].id)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "マジかるベルトはシミュレータ上で表示されません"))
            : _createCommentVNode("", true),
          (!_ctx.isAllConfigSet)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "選択内容をご確認の上でご注文にお進み下さい"))
            : _createCommentVNode("", true),
          (_ctx.showButtons)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_CopyLinkButton, { isMobile: false }),
                _createVNode(_component_CheckoutButton)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.showButtons)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (!_ctx.isAllConfigSet)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "未選択の項目があります"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_CopyLinkButton, { isMobile: true }),
                _createElementVNode("button", {
                  class: "button open-greenboard",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openGreenboard && _ctx.openGreenboard(...args)))
                }, "組み合わせ確認")
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_CheckoutButton)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["index"]))
}